import { render, staticRenderFns } from "./GuangzhouTelecomAd.vue?vue&type=template&id=110753bb&scoped=true"
import script from "./GuangzhouTelecomAd.vue?vue&type=script&lang=js"
export * from "./GuangzhouTelecomAd.vue?vue&type=script&lang=js"
import style0 from "./GuangzhouTelecomAd.vue?vue&type=style&index=0&id=110753bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110753bb",
  null
  
)

export default component.exports